"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUnits = void 0;
function parseUnits(value, decimals) {
  let [integer, fraction = '0'] = value.split('.');
  const negative = integer.startsWith('-');
  if (negative) integer = integer.slice(1);
  fraction = fraction.replace(/(0+)$/, '');
  if (decimals === 0) {
    if (Math.round(Number(".".concat(fraction))) === 1) integer = "".concat(BigInt(integer) + 1n);
    fraction = '';
  } else if (fraction.length > decimals) {
    const [left, unit, right] = [fraction.slice(0, decimals - 1), fraction.slice(decimals - 1, decimals), fraction.slice(decimals)];
    const rounded = Math.round(Number("".concat(unit, ".").concat(right)));
    if (rounded > 9) fraction = "".concat(BigInt(left) + BigInt(1), "0").padStart(left.length + 1, '0');else fraction = "".concat(left).concat(rounded);
    if (fraction.length > decimals) {
      fraction = fraction.slice(1);
      integer = "".concat(BigInt(integer) + 1n);
    }
    fraction = fraction.slice(0, decimals);
  } else {
    fraction = fraction.padEnd(decimals, '0');
  }
  return BigInt("".concat(negative ? '-' : '').concat(integer).concat(fraction));
}
exports.parseUnits = parseUnits;
//# sourceMappingURL=parseUnits.js.map